import {tx, ptx, usePageText} from '../lib/page-text';
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api-client";
import { EmptyState } from "../components/ui";
import { RecordingsIcon } from "../components/icons";
import { RequestFeedback } from "../components/RequestFeedback";
import { useT } from "../lib/i18n";
import { ReplayLibrary } from "../components/ReplayLibrary";

export function RecordingsPage() {
  usePageText();
  const { t } = useT();
  const list = useQuery({
    queryKey: ["recordings"],
    queryFn: async () => (await api.get("/me/recordings")).data,
    refetchInterval: 15_000,
  });
  return (
    <div>
      <h1 className="h1">{tx("Recordings")}</h1>
      <p className="subtitle">{t("dashboard.recordingsIntro")}</p>
      <RequestFeedback
        pending={list.isPending}
        failed={list.isError}
        hasData={!!list.data}
        retry={() => void list.refetch()}
        retrying={list.isFetching}
      />
      {list.data &&
        (list.data.length === 0 ? (
          <EmptyState
            icon={<RecordingsIcon />}
            title={tx("No recordings yet")}
            body={tx("Saved replays appear here after a broadcast finishes with recording enabled.")}
          />
        ) : (
          <ReplayLibrary recordings={list.data} />
        ))}
    </div>
  );
}
